// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';

export const S = {
  LevelContainer: styled.div`
    display: flex;
    align-items: center;
    * {
      margin: 0px 1px;
    }
`,
  LevelPillOrange: styled.div`
    background: #EF8200;
    border-radius: 2px;
    width: 4px;
    height: 10px;
`,
  LevelPill: styled.div`
    background: #DEDEDE;
    border-radius: 2px;
    width: 4px;
    height: 10px;
`,
  LevelName: styled.div<{namePosition?:'left'}>`
  ${props => props.namePosition === 'left'? `
    font-family: Noto Sans TC;
    font-size: 16px;
    line-height: 23px;
    color: #434343;`:
  `
    font-weight: 500;
    font-size: 12px;
  `}

    color: #434343;
    ${props => props.namePosition === 'left'? 'margin-left: 10px;':'margin-right: 10px;' }
`
}
